export default{
    data(){
        return {
            testDate:[
                {name:'物化学理',id:1},
                {name:'化学物理',id:2},
                {name:'生物物理',id:3},
                {name:'语物理文',id:4},
                {name:'物理数学',id:5},
                {name:'物理生物',id:3},
                {name:'物理语文',id:4},
                {name:'物理数学',id:5},
            ]
        }
    },
    methods:{

    },

}